import { useCallback } from 'react';
import { extractEncodedId } from '@ads/utils/extractEncodedId';
import { pruneNilValues } from '@core/object';
import { appContextToTrackingDataPixel, sendPixelTrackingWithSession, } from '@core/tracking';
import { useStoreApi } from '@core/widgets/store';
import { customEmbedEvent, EventType } from '@embed/customEmbedEvent';
import { ENGAGEMENT_CLICK_CTA, ENGAGEMENT_INTERACTABLE_VIEW, ENGAGEMENT_INTERACTABLE_VIEW_V2, } from './endpoints/engagement';
/**
 * Hook that provides a callback for tracking of CTA click pixel event.
 */
export const useTrackCTAClick = (video) => {
    const store = useStoreApi();
    return useCallback((appContext) => {
        const { params } = store.getState();
        const { action_type, action_url, variant } = video ?? {};
        const pixelTrackingData = appContextToTrackingDataPixel({ appContext });
        if (action_type && action_url) {
            const pixelData = {
                event_properties: pruneNilValues({
                    ...pixelTrackingData,
                    variant,
                    _video_id: extractEncodedId(video),
                    action_type: video?.action_type,
                    action_url: video?.action_url,
                }),
            };
            customEmbedEvent({
                type: EventType.FW_EMBEDFEED_CTA_CLICK,
                params,
            });
            sendPixelTrackingWithSession({
                host: params?.api_host_tracking,
                endpoint: ENGAGEMENT_CLICK_CTA,
                data: pixelData,
            });
            sendPixelTrackingWithSession({
                host: params?.api_host_tracking,
                endpoint: ENGAGEMENT_INTERACTABLE_VIEW,
                data: pixelData,
            });
            sendPixelTrackingWithSession({
                host: params?.api_host_tracking,
                endpoint: ENGAGEMENT_INTERACTABLE_VIEW_V2,
                data: pixelData,
            });
        }
    }, [store, video]);
};
